import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { TourOverlayComponent } from './tour-overlay.component';

@NgModule({
  declarations: [TourOverlayComponent],
  imports: [CommonModule, TranslateModule],
  exports: [TourOverlayComponent]
})
export class TourOverlayModule {}
